import { VhcRecordLogService } from 'api/generated';
import { QueryError } from 'features/shared/model';
import { useQuery, UseQueryOptions } from 'react-query';

export type GetVhcRecordLaboursInput = {
  id: number;
};

export const useRecordLaboursQueryKey = 'RecordLaboursQueryKey';

export const fetchVhcRecordLabours = async (vhcRecord: number) => {
  const data = await VhcRecordLogService.getVhcRecordsLabours(vhcRecord);
  const { checkBrakeItemLabours, checkItemLabours, checkWheelTyreItemLabours } = data || {};

  const items = [...(checkBrakeItemLabours ?? []), ...(checkItemLabours ?? []), ...(checkWheelTyreItemLabours ?? [])];

  return {
    items: items.length > 0 ? items : null
  };
};

export const useGetVhcRecordLaboursQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  id: number,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchVhcRecordLabours>>,
      QueryError,
      Awaited<ReturnType<typeof fetchVhcRecordLabours>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([useRecordLaboursQueryKey, ...(queryKey ?? [id])], () => fetchVhcRecordLabours(id), options);
